<template>
  <v-card
    outlined
  >
    <v-card-text>
      <v-row>
        <v-col cols="9">
          <v-tooltip top>
            <template #activator="{ on }">
              <v-chip color="primary" class="mr-2 font-weight-bold" dark v-on="on">
                <v-icon left>mdi-cog-outline</v-icon>{{ getLabel(restriction.type) }}
              </v-chip>
            </template>
            <span>{{ getLabel("permission_type") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-chip v-on="on">{{ restriction.project }}</v-chip>
            </template>
            <span>{{ getLabel("project") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="3" class="text-right">
          <v-btn v-if="editMode && !restriction.group" icon @click="editRestriction">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-if="editMode && !restriction.group" icon @click="removeRestriction">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-chip v-if="restriction.group">{{ restriction.group }}</v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="hasLimitedContentTypes || hasContentTypes ? 6 : 12">
          <div class="subheading font-weight-bold">{{ getLabel("workspaces") }}</div>
          <v-chip
            v-for="workspace in restriction.workspaces"
            :key="workspace"
            color="#d6857a"
            class="ma-1"
            small
          >
            {{ workspace === "*" ? getLabel("all_workspaces") : getWorkspaceLabel(workspace) }}
          </v-chip>
        </v-col>
        <v-col v-if="hasContentTypes" cols="6">
          <div>
            <div class="subheading font-weight-bold">
              {{ getLabel("content_types") }}
            </div>
            <v-chip
              v-for="content_type in restriction.settings.content_types"
              :key="content_type"
              color="#d6857a"
              class="ma-1"
              small
            >
              {{ content_type === "*" ? getLabel("all_values") : getContentTypeLabel(content_type) }}
            </v-chip>
          </div>
        </v-col>
        <v-col v-if="hasLimitedContentTypes" cols="3">
          <div>
            <div class="subheading font-weight-bold">
              {{ getLabel("content_types") }}
            </div>
            <v-chip
              color="#d6857a"
              class="ma-1"
              small
            >
              {{ getContentTypeLabel(restriction.settings.content_type) }}
            </v-chip>
          </div>
        </v-col>
        <v-col v-if="hasLimitedContentTypes" cols="3">
          <div>
            <div class="subheading font-weight-bold">
              {{ getLabel("limited_contents") }}
            </div>
            <v-chip
              color="#d6857a"
              class="ma-1"
              small
            >
              {{ limitedContentsNumber() }}
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, computed } from '@vue/composition-api';

import { getLabel, getWorkspaceLabel, getContentTypeLabel } from '@/utils/index';

export default {
  props: {
    restriction: {
      type: Object,
      required: true
    },
    removeRestriction: {
      type: Function,
      default: null,
      required: false
    },
    editRestriction: {
      type: Function,
      default: null,
      required: false
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const hasLimitedContentTypes = computed(() => props.restriction.settings && props.restriction.settings.limited_contents);

    const hasContentTypes = computed(() => props.restriction.settings && props.restriction.settings.content_types);

    const limitedContentsNumber = () => props.restriction.settings.limited_contents.length;

    return { getLabel, getWorkspaceLabel, getContentTypeLabel, hasLimitedContentTypes, hasContentTypes, limitedContentsNumber };
  }
};
</script>
